import * as React from 'react';
import { MIN_PASSWORD_LENGTH } from 'Auth/Data';

interface Props {
  onSubmit: (
    currentPassword: string,
    newPassword: string,
    onSuccess: () => void,
    onError: (msg: string) => void
  ) => void
}

interface State {
  currentPassword: string,
  password: string,
  passwordConfirmation: string,
  error?: string
}

const INITIAL_STATE: State = {
  currentPassword: '',
  password: '',
  passwordConfirmation: '',
  error: undefined
}

class ChangePasswordForm extends React.Component<Props, State> {
  onCurrentPasswordChange: (e: React.FormEvent<HTMLInputElement>) => void

  onPasswordChange: (e: React.FormEvent<HTMLInputElement>) => void

  onPasswordConfirmationChange: (e: React.FormEvent<HTMLInputElement>) => void

  constructor(props: Props) {
    super(props);
    this.state = INITIAL_STATE;

    this.onSubmit = this.onSubmit.bind(this);
    this.onCurrentPasswordChange = this.onFieldChange('currentPassword').bind(this);
    this.onPasswordChange = this.onFieldChange('password').bind(this);
    this.onPasswordConfirmationChange =
      this.onFieldChange('passwordConfirmation').bind(this);
  }

  onFieldChange(
    fieldName: keyof State
  ): (e: React.FormEvent<HTMLInputElement>) => void {
    return e => {
      const el = e.target as HTMLInputElement;
      this.setState({
        ...this.state,
        [fieldName]: el.value
      });
    };
  }

  onSubmit(e: React.FormEvent<any>) {
    e.preventDefault();
    const error = passwordError(this.state);

    if (error) {
      this.setState({ ...this.state, error });
    } else {
      this.setState({ ...this.state, error: undefined });
      this.props.onSubmit(
        this.state.currentPassword,
        this.state.password,
        this.clearFields,
        this.showServerError
      );
    }
  }

  clearFields = () => this.setState(INITIAL_STATE)

  showServerError = (msg: string) => this.setState({ ...this.state, error: msg })

  render() {
    return (
      <form
        onSubmit={this.onSubmit} className="change-pwd-form simple-container">
        {renderTips(this.state)}

        <div className="mb-10">
          <input type="password"
            value={this.state.currentPassword}
            onChange={this.onCurrentPasswordChange}
            placeholder="Current password"
            autoComplete="current-password"
            required
            className="text-field text-field--block"/>
        </div>
        <div className="mb-10">
          <input type="password"
            value={this.state.password}
            onChange={this.onPasswordChange}
            placeholder="New password"
            autoComplete="new-password"
            required
            className="text-field text-field--block"/>
        </div>
        <div className="mb-10">
          <input type="password"
            value={this.state.passwordConfirmation}
            onChange={this.onPasswordConfirmationChange}
            required
            placeholder="Confirm password"
            autoComplete="new-password"
            className="text-field text-field--block"/>
        </div>
        <div className="mb-10 clearfix">
          <button type="submit"
            className="button button-fixed-width button-gray">
            change password
          </button>
        </div>
      </form>
    );
  }
}

export default ChangePasswordForm;

function passwordError(
  { password, passwordConfirmation }: State
): string | undefined {
  if (password !== passwordConfirmation) {
    return 'Password confirmation does not match';
  } else if (password.length < MIN_PASSWORD_LENGTH) {
    return `Password must be at least ${MIN_PASSWORD_LENGTH} characters`;
  }
}

function renderTips(state: State): React.ReactNode {
  const classNames = state.error ? 'error-text' : '';
  const content =
    state.error ? state.error : `Password must be at least ${MIN_PASSWORD_LENGTH} characters`;
  return (
    <p className={classNames}>
      {content}
    </p>
  );
}
